import { LATEST_MATCHES_LIMIT } from 'modules/main/domain/const/latest-matches';
import { mapLatestMatches } from 'modules/main/domain/data-mappers/latest-matches.data-mapper';
import { LATEST_MATCHES_QUERY, type LatestMatchDto } from 'modules/main/domain/graphql/latest-matches';
import type { LatestMatch } from 'modules/main/domain/interfaces/latest-match';
import { baseApi } from 'shared/api/base-api';

export const latestMatchesApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /** Последние матчи организации; аргумент — id организации (в GraphQL это `tournamentId`). */
    latestMatches: build.query<LatestMatch[], number>({
      query: (organizerId) => ({
        query: LATEST_MATCHES_QUERY,
        variables: { tournamentId: organizerId, limit: LATEST_MATCHES_LIMIT },
      }),
      transformResponse: (raw: { previousMatches: LatestMatchDto[] | null }) => mapLatestMatches(raw.previousMatches ?? []),
    }),
  }),
});

export const { useLatestMatchesQuery } = latestMatchesApi;
